import $axios from 'axios'
import {
  loginUri,
  queryAuthUri,
  sendCodeUri,
  checkCodeUri,
  getSignatureUri,
  getlistByCodeUri,
  getJobDetailUri,
  setCollectionUri,
  createCodeUri,
  jobRecommendIndexUri,
  jobShareIndexUri,
  getTemplateListUri,
  collectionListUri,
  historyJobUri,
  userInfoUri,
  autoLogoutUri,
  getOpenidUri,
  getOpenIdLoginUri,
  logoutUri,
  loginOrRegUri,
  workbenchUri,
  createPositionContractUri,
  REQUEST_IS_SYBCYIMAI,
  privacyNumberUri,
  jobShareParameterUri,
  uploadUrl,
  authenticationUrl,
  authenticationStatusUrl,
  getActivityUrl,
  addUsreToQiyuesuoUri,
  positionContractOfficial,
  uploadBusinessLicense,
  getCompanyDetailUri,
  addJobViewRecordUri,
  setBehavioralDataUri,
  getUserInfoByJobId,
  GET_OBS_URL,
  jobPackageStatisticsUri,
} from '../config/uri'

//举例
// 登录接口：
export function login(params) {
  return $axios.post(loginUri, params)
}
// 查询用户权限接口
export function queryAuth(params) {
  return $axios.post(queryAuthUri, params)
}

// 获取短信接口
export function getSms(params) {
  return $axios.post(sendCodeUri, params)
}

// 校验短信接口
export function checkSms(params) {
  return $axios.post(checkCodeUri, params)
}

// 获取微信公众号签名接口：
// http://dev.hewa.cn:8080/web/#/8?page_id=294
export function getSignature(params) {
  return $axios.post(getSignatureUri, params)
}
// 职位推荐(小蛙推荐)根据code获取列表接口：短信邮件链接
// http://dev.hewa.cn:8080/web/#/8?page_id=286
export function getListByCode(params) {
  return $axios.post(getlistByCodeUri, params)
}

// 查询职位详情接口：
// http://dev.hewa.cn:8080/web/#/8?page_id=284
export function getJobDetail(params) {
  return $axios.post(getJobDetailUri, params)
}

// 收藏接口：
// http://dev.hewa.cn:8080/web/#/8?page_id=284
export function setCollection(params) {
  return $axios.post(setCollectionUri, params)
}

// 职位分享生成二维码（扫码一键分享）
// http://dev.hewa.cn:8080/web/#/8?page_id=287
export function createQRCode(params) {
  return $axios.post(createCodeUri, params)
}

// 职位推荐(小蛙推荐)/历史推荐列表接口 (登录后查看更多--底部登录)
// http://dev.hewa.cn:8080/web/#/8?page_id=285
export function getRecommendList(params) {
  return $axios.post(jobRecommendIndexUri, params)
}

// 职位分享列表接口 --后台链接出来
// http://dev.hewa.cn:8080/web/#/8?page_id=283
export function getShareList(params) {
  return $axios.post(jobShareIndexUri, params)
}
// 获取用户协议
export function getAgreementUrl(params) {
  return $axios.post(getTemplateListUri, params)
}

// 搜藏
export function getCollectionList(params) {
  return $axios.post(collectionListUri, params)
}
// 历史记录
export function getHistoryJob(params) {
  return $axios.post(historyJobUri, params)
}
//个人信息
export function getUserInfo(params) {
  return $axios.post(userInfoUri, params)
}
//登退
export function getAutoLogout(params) {
  return $axios.post(autoLogoutUri, params)
}
//获取openid
export function getOpenid(params) {
  return $axios.post(getOpenidUri + '?code=' + params.code)
}
//openId登陆
export function getOpenIdLogin(params) {
  return $axios.post(getOpenIdLoginUri, params)
}
//退出登录
export function getLogout(params) {
  return $axios.post(logoutUri, params)
}
// 绑定或注册
export function getloginOrReg(params) {
  return $axios.post(loginOrRegUri, params)
}
//工作台
export function getWorkbench(params) {
  return $axios.post(workbenchUri, params)
}
// 接单并生成合同
export function getCreatePositionContract(params) {
  return $axios.post(createPositionContractUri, params)
}
export function isYIMAIJob(params) {
  return $axios.post(REQUEST_IS_SYBCYIMAI, params)
}
// 接单后的佣金协议
export function getPositionContractOofficial(params) {
  return $axios.post(positionContractOfficial, params)
}

// 文件上传
export function getUpload(params) {
  const data = new FormData()
  data.append('file', params.file)
  data.append('type', params.type)
  let headers = {
    'Content-Type': 'multipart/form-data',
    setToken: false,
  }
  return $axios.post(uploadUrl, data, headers)
}
// 营业执照上传
export function getUploadBusinessLicense(params) {
  const data = new FormData()
  data.append('file', params.file)
  let headers = {
    'Content-Type': 'multipart/form-data',
    setToken: false,
  }
  return $axios.post(uploadBusinessLicense, data, headers)
}

// 实名认证-----------------------7
export function getAuthentication(params) {
  return $axios.post(authenticationUrl, params)
}

// 实名认证状态查询-----------------------7
export function getAuthenticationStatus(params) {
  return $axios.post(authenticationStatusUrl, params)
}
// 获取隐私号
export function getPrivacyNumber(params) {
  return $axios.post(privacyNumberUri, params)
}
// 职位分享内容
export function getJobShareParameter(params) {
  return $axios.post(jobShareParameterUri, params)
}

// 活动相关
export function getActivityUrlData(params) {
  return $axios.post(getActivityUrl, params)
}
// 自动加入契约锁
export function getAddUsreToQiyuesuo(params) {
  return $axios.post(addUsreToQiyuesuoUri, params)
}

// 获取用人单位信息
export function getCompanyDetail(params) {
  return $axios.post(getCompanyDetailUri, params)
}

// 行为上报
export function addJobViewRecord(params) {
  return $axios.post(addJobViewRecordUri, params)
}
// 数据上报
export function setBehavioralData(params) {
  return $axios.post(setBehavioralDataUri, params)
}

/**
 * 职位收藏
 * @param {*} data
 */
export function postsetCollection(data) {
  return $axios.post('/hewaCoreUser/pc/userBehavior/addJobCollectRecord', data)
}
/**
 * 职位取消
 * @param {*} data
 * @returns
 */
export function delPostsetCollection(data) {
  return $axios.post('/hewaCoreUser/pc/userBehavior/delJobCollectRecord', data)
}
/**
 * 职位佣金规则查询
 * @param {*} data
 * @returns
 */
export function getJobCommissionRule(data) {
  return $axios.post('/hewaCorePosition/pc/gear/getJobCommissionRules', data)
}
/**
 * 获取发单顾问信息
 * @param {*} data
 * @returns
 */
export function getUserInfoByJobIds(data) {
  return $axios.post(getUserInfoByJobId, data)
}

//预览简历接口获取真是obs路径
export function getObsUrl(params) {
  return $axios.post(GET_OBS_URL, params, {
    isloading: false,
  })
}

//职位包统计接口
export function jobPackageStatistics(params) {
  return $axios.post(jobPackageStatisticsUri, params, {
    isloading: false,
  })
}
